/* eslint-disable react/jsx-props-no-spreading */
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { ChangeEvent, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Dropzone, { FileRejection } from "react-dropzone";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import * as XLSX from "xlsx";
import {
    axiosGetRequest,
    axiosPostRequest,
    axiosPutRequest,
} from "../api/ApiClient";
import { ReactComponent as InformationModal } from "../assets/icons/InformationModal.svg";
import { ReactComponent as UploadIcon } from "../assets/icons/UploadArrowIcon.svg";
import { ReactComponent as ClipIcon } from "../assets/icons/Clip.svg";
import TemplateAprovadoresPlanoAtividade from "../assets/templates/Template_Aprovadores_Plano_Atividade.xlsx";
import TemplateAtividadeEsporadica from "../assets/templates/Template_Atividade_Esporadica.xlsx";
import TemplateContratoProfessores from "../assets/templates/Template_Contrato_Professores.xlsx";
import TemplateCentroResultados from "../assets/templates/Template_CRs.xlsx";
import TemplateEstudantes from "../assets/templates/Template_Estudantes.xlsx";
import TemplateHoraLetiva from "../assets/templates/Template_Hora_Letiva.xlsx";
import TemplateHorasNaoLetivaMatrizCurricular from "../assets/templates/Template_Hora_Nao_Letiva_Matriz_Curricular.xlsx";
import TemplateListaAtividade from "../assets/templates/Template_Lista_Atividade.xlsx";
import TemplateReservaCargaHoraria from "../assets/templates/Template_Reserva_Carga_Horaria.xlsx";
import TemplateHoraLetivaRE from "../assets/templates/Template_Hora_Letiva_RE.xlsx";
import TemplateHistoricoCargaHoraria from "../assets/templates/Template_Historico_Carga_Horaria.xlsx";
import Dialog from "../components/Dialog";
import InputSelect from "../components/InputSelect";
import InputTextArea from "../components/InputTextArea";
import UploadFileDTO from "../model/dto/UploadFileDTO";
import { TipoTemplateEnumList } from "../model/Enums/TipoTemplateEnum";
import OptionsSelect from "../model/OptionsSelect";
import { StyledBody, StyledHeader, StyledLabel } from "../styles/MainStyles";
import UploadFileStyles from "../styles/pages/UploadFilesStyles";
import GenericUtils from "../utils/GenericUtils";
import StringUtils from "../utils/types/StringUtils";

const {
    StyledDropContainer,
    StyledDropzoneButton,
    StyledDropzoneError,
    StyledDropzoneParagraph,
    StyledDropzoneTitle,
    StyledDownloadButton,
    StyledImportButton,
    StyledModalFooter,
    StyledModalFooterLink,
    StyledModalText,
    StyledModalTitle,
    StyledParagraph,
    StyledFileName,
    StyledFileSize,
    StyledImportTitle,
    StyledImportSubTitle,
    StyledFileInformationDiv,
    StyledContainerDropzone,
    StyledHr,
} = UploadFileStyles;

function UploadFile() {
    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenTemplateManager();
    const user = GenericUtils.getUser();

    const [open, setOpen] = useState(false);
    const [select, setSelect] = useState("");
    const [textArea, setTextArea] = useState("");
    const [error, setError] = useState<string>();
    const [isError, setIsError] = useState(false);
    const [upload, setUpload] = useState(true);
    const [newfile, setNewFile] = useState<File[]>();
    const [columns, setColumns] = useState<string[]>([]);
    const [selectTemplate, setSelectTemplate] = useState("");
    const [errorPost, setErrorPost] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [urlResponse, setUrlResponse] = useState();
    const [templates, setTemplates] = useState<OptionsSelect[]>([]);
    const [typeTemplates, setTypeTemplates] = useState<OptionsSelect[]>([]);

    const { t } = useTranslation();
    const placeholder = StringUtils.capitalizeFirstLetter(
        t("uploadInformation")
    );
    const dropFile = StringUtils.capitalizeFirstLetter(t("dropFiles"));
    const dragFileText = StringUtils.capitalizeFirstLetter(t("dragFile"));
    const selectFileText = StringUtils.capitalizeFirstLetter(t("selectFile"));
    const uploadSuccessfulText = StringUtils.capitalizeFirstLetter(
        t("uploadSuccessful")
    );
    const uploadErroText = StringUtils.capitalizeFirstLetter(
        t("invalidTemplate")
    );
    const noFileSelectedText = StringUtils.capitalizeFirstLetter(
        t("noFileSelected")
    );
    const unsupportedfFileText = StringUtils.capitalizeFirstLetter(
        t("unsupportedfFile")
    );

    const acceptFiles = {
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
            ".xlsx ",
        ],
    };

    const [uploadFileDTO, setUploadFileDTO] = useState<UploadFileDTO>({
        tipoTemplate: "",
        nomeArquivo: "",
        observacao: "",
        cabecalhoTemplate: [],
    });

    async function getData() {
        const newTemplate: OptionsSelect[] = [
            {
                value: "",
                text: "Selecionar template",
            },
        ];
        const response = await axiosGetRequest(
            "/template-manager/v1/cargas/tipo-arquivo-template",
            acessToken,
            instance
        );

        if (GenericUtils.isSuccessStatus(response)) {
            response?.data.map((data: any) =>
                newTemplate.push({
                    value: data.tipoArquivoTemplateId,
                    text:
                        data.tipoArquivoTemplateId === 10
                            ? "Hora Letiva RE"
                            : data.descricao,
                })
            );

            setTemplates(newTemplate);
        }
    }

    const params = JSON.stringify({
        tipoTemplate: Number(uploadFileDTO.tipoTemplate),
        nomeArquivo: uploadFileDTO.nomeArquivo,
        observacao: uploadFileDTO.observacao,
        cabecalhoTemplate: uploadFileDTO.cabecalhoTemplate,
    });

    const paramsUpdate = JSON.stringify({
        tipoTemplate: Number(uploadFileDTO.tipoTemplate),
        nomeArquivo: uploadFileDTO.nomeArquivo,
        observacao: uploadFileDTO.observacao,
        usuario: user?.docente?.emailProfessor,
    });

    async function postUpload() {
        const response = await axiosPostRequest(
            "/template-manager/v1/templates/upload",
            params,
            acessToken,
            instance
        );

        if (response.data.status === 400) {
            setErrorPost(response.data.title);
            console.log(response.data.title);
        }

        setUrlResponse(response.data.url);
        setUpload(false);
    }

    async function postUrlUpload(url: string) {
        await axios
            .put(url, newfile?.[0], {
                headers: {
                    "x-ms-blob-type": "BlockBlob",
                },
            })
            .then(() => {
                setOpen(true);
                setOpenModal(true);
            })
            .catch((erro) => setErrorPost(erro.response.data));
    }

    async function putFile() {
        await axiosPutRequest(
            "/template-manager/v1/templates/cargas-historico",
            paramsUpdate,
            acessToken,
            instance
        );
        setNewFile([]);
    }

    useEffect(() => {
        if (errorPost) {
            setOpen(true);
        }
    }, [errorPost]);

    useEffect(() => {
        getData();
        const enumList = TipoTemplateEnumList();

        enumList.sort((a, b) => {
            // eslint-disable-next-line no-nested-ternary
            return a.text === b.text ? 0 : a.text > b.text ? 1 : -1;
        });

        enumList.unshift({
            value: "",
            text: "Selecionar modelo",
        });
        setTypeTemplates(enumList);
    }, []);

    useEffect(() => {
        if (openModal) {
            putFile();
        }
    }, [openModal]);

    useEffect(() => {
        if (!newfile) {
            return;
        }
        if (urlResponse) {
            postUrlUpload(urlResponse);
        }
    }, [urlResponse]);

    useEffect(() => {
        setUploadFileDTO({
            tipoTemplate: select,
            nomeArquivo: newfile?.[0]?.name || "",
            observacao: textArea,
            cabecalhoTemplate: columns,
        });
    }, [select, newfile, columns, textArea]);

    const handleSelectChange = (event: ChangeEvent<{ value: unknown }>) => {
        setSelect(event.target.value as string);
    };

    const handleTemplateSelectChange = (
        event: ChangeEvent<{ value: unknown }>
    ) => {
        setSelectTemplate(event.target.value as string);
    };

    const handleTextAreaChange = (event: ChangeEvent<{ value: unknown }>) => {
        setTextArea(event.target.value as string);
    };

    const renderMessageError = (fileRejections: FileRejection[]) => {
        if (fileRejections && isError) {
            return (
                <StyledDropzoneError>
                    <StyledDropzoneParagraph>{error}</StyledDropzoneParagraph>
                </StyledDropzoneError>
            );
        }

        return null;
    };

    const handleUploadFile = () => {
        setErrorPost("");
        setUpload(false);
        postUpload();
    };

    const handleRedirect = () => {};

    const handleClose = () => {
        setOpen(false);
        setOpenModal(false);
    };

    const handleTemplateDownload = () => {
        let template = "";
        let nameFile = "";

        if (selectTemplate === "1") {
            template = TemplateHoraLetiva;
            nameFile = "Template_Hora_Letiva";
        }

        if (selectTemplate === "2") {
            template = TemplateReservaCargaHoraria;
            nameFile = "Template_Reserva_Carga_Horaria";
        }

        if (selectTemplate === "3") {
            template = TemplateListaAtividade;
            nameFile = "Template_Lista_Atividade";
        }

        if (selectTemplate === "4") {
            template = TemplateCentroResultados;
            nameFile = "Template_CRs";
        }

        if (selectTemplate === "5") {
            template = TemplateHorasNaoLetivaMatrizCurricular;
            nameFile = "Template_Hora_Nao_Letiva_Matriz_Curricular";
        }

        if (selectTemplate === "6") {
            template = TemplateEstudantes;
            nameFile = "Template_Estudantes";
        }

        if (selectTemplate === "7") {
            template = TemplateAprovadoresPlanoAtividade;
            nameFile = "Template_Aprovadores_Plano_Atividade";
        }

        if (selectTemplate === "8") {
            template = TemplateContratoProfessores;
            nameFile = "Template_Contrato_Professores";
        }

        if (selectTemplate === "9") {
            template = TemplateAtividadeEsporadica;
            nameFile = "Template_Atividade_Exporadica";
        }

        if (selectTemplate === "10") {
            template = TemplateHoraLetivaRE;
            nameFile = "Template_Hora_Letiva_RE";
        }

        if (selectTemplate === "11") {
            template = TemplateHistoricoCargaHoraria;
            nameFile = "Template_Historico_Carga_Horaria";
        }

        const link = document.createElement("a");
        link.href = template;
        link.setAttribute("download", `${nameFile}.xlsx`);

        document.body.appendChild(link);
        link.click();
        link?.parentNode?.removeChild(link);
    };

    function formatBytes(bytes: any, decimals = 2) {
        if (bytes === 0) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
    }

    const convertedSize = formatBytes(newfile?.[0]?.size);

    const dropzoneDefault = (
        <StyledContainerDropzone>
            <UploadIcon style={{ margin: "40px 0 20px 0" }} />
            <StyledDropzoneTitle>{dragFileText}</StyledDropzoneTitle>
            <StyledDropzoneButton style={{ margin: "20px 0 30px 0" }}>
                {selectFileText}
            </StyledDropzoneButton>
            <div>{noFileSelectedText}</div>
        </StyledContainerDropzone>
    );

    const dropzoneWithFile = (
        <StyledContainerDropzone>
            <StyledFileInformationDiv>
                <ClipIcon />
                <StyledFileName>{newfile?.[0]?.name}</StyledFileName>
                <p style={{ margin: 0, color: "#E4E4E4" }}>|</p>
                <StyledFileSize>{convertedSize}</StyledFileSize>
            </StyledFileInformationDiv>
        </StyledContainerDropzone>
    );

    const renderDragMessage = (
        isDragActive: boolean,
        isDragReject: boolean
    ) => {
        if (!isDragActive) {
            return (
                <Container>
                    {newfile && upload ? dropzoneWithFile : dropzoneDefault}
                </Container>
            );
        }

        if (isDragReject) {
            setError("");
            setIsError(false);
            return <StyledParagraph>{unsupportedfFileText}</StyledParagraph>;
        }

        setIsError(false);
        setError("");
        return <StyledParagraph>{dropFile}</StyledParagraph>;
    };

    const handleUpload = (file: File[]) => {
        const date = new Date();
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        const hour = `0${date.getHours()}`.slice(-2);
        const minutes = `0${date.getMinutes()}`.slice(-2);
        const seconds = `0${date.getSeconds()}`.slice(-2);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();

        const renameFile = new File(
            file,
            `${year}_${month}_${day}_${hour}_${minutes}_${seconds}_${file[0].name}`
        );

        const fileBlob = new Blob([renameFile]);
        reader.readAsArrayBuffer(fileBlob);
        reader.onload = (e) => {
            const bufferArray = e?.target?.result;

            const wb = XLSX.read(bufferArray, {
                type: rABS ? "binary" : "array",
            });

            const wsName = wb.SheetNames[0];
            const ws = wb.Sheets[wsName];

            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

            setColumns(data[0] as string[]);
        };

        setNewFile([renameFile]);
        setIsError(false);
        setUpload(true);
        setError("");
    };

    const handleReject = (file: FileRejection[]) => {
        if (file[0].errors[0].code === "file-invalid-type") {
            setError(
                StringUtils.capitalizeFirstLetter(t("onlyFilesExtensions"))
            );
        }

        setIsError(true);
        setUpload(false);
        setNewFile([]);
    };

    const DialogSuccessActions = (
        <StyledModalFooter>
            <StyledModalFooterLink
                style={{ marginBottom: "40px" }}
                onClick={handleClose}
            >
                Novo Upload
            </StyledModalFooterLink>
        </StyledModalFooter>
    );

    const DialogErrorActions = (
        <StyledModalFooter>
            <StyledModalFooterLink onClick={handleClose}>
                Fechar
            </StyledModalFooterLink>
        </StyledModalFooter>
    );

    const DialogSuccessContent = (
        <Dialog
            openModal={open}
            onHide={handleClose}
            actions={DialogSuccessActions}
        >
            <StyledModalTitle>{uploadSuccessfulText}</StyledModalTitle>
            <StyledModalText>
                {StringUtils.capitalizeFirstLetter(t("trackFileStatus"))}
            </StyledModalText>
            <Link to="/historico">
                <StyledImportButton
                    style={{ width: 152 }}
                    onClick={handleRedirect}
                >
                    Acompanhar
                </StyledImportButton>
            </Link>
        </Dialog>
    );

    const DialogErrorContent = (
        <Dialog
            openModal={open}
            onHide={handleClose}
            actions={DialogErrorActions}
            modalIcon={<InformationModal />}
        >
            <StyledModalTitle>{uploadErroText}</StyledModalTitle>
            <StyledModalText>
                {StringUtils.capitalizeFirstLetter(
                    t("pleaseSelectAnotherImport")
                )}
            </StyledModalText>
        </Dialog>
    );

    return (
        <ThemeProvider theme={{}}>
            <StyledHeader>
                <StyledImportTitle style={{ marginBottom: "16px" }}>
                    {StringUtils.capitalizeFirstLetter(t("attachFile"))}
                </StyledImportTitle>
                <StyledImportSubTitle style={{ margin: 0, padding: 0 }}>
                    {StringUtils.capitalizeFirstLetter(t("onlyOneFile"))}
                </StyledImportSubTitle>
                <StyledImportSubTitle>
                    {StringUtils.capitalizeFirstLetter(t("nextStep"))}
                </StyledImportSubTitle>
            </StyledHeader>
            <StyledBody>
                <div
                    style={{
                        maxWidth: "860px",
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <InputSelect
                        value={selectTemplate}
                        handleSelectChange={handleTemplateSelectChange}
                        optionsSelect={typeTemplates}
                        style={{
                            border: "none",
                            boxShadow: "2px 3px 4px rgba(0, 0, 0, 0.1)",
                            padding: "8px, 16px",
                            width: "704px",
                        }}
                    />
                    <StyledDownloadButton
                        disabled={selectTemplate === ""}
                        onClick={handleTemplateDownload}
                    >
                        Download
                    </StyledDownloadButton>
                </div>
                <StyledHr />

                <div style={{ maxWidth: "704px" }}>
                    <StyledLabel style={{ marginBottom: "10px" }}>
                        {StringUtils.capitalizeFirstLetter(t("selectTemplate"))}
                    </StyledLabel>
                    <InputSelect
                        value={select}
                        handleSelectChange={handleSelectChange}
                        optionsSelect={templates}
                    />
                    <div style={{ height: "290px", marginTop: "35px" }}>
                        <StyledLabel style={{ marginBottom: "10px" }}>
                            {StringUtils.capitalizeFirstLetter(
                                t("attachFileLabel")
                            )}
                        </StyledLabel>
                        <Dropzone
                            accept={acceptFiles}
                            onDropAccepted={handleUpload}
                            onDropRejected={handleReject}
                        >
                            {({
                                getRootProps,
                                getInputProps,
                                isDragActive,
                                isDragReject,
                                fileRejections,
                            }) => (
                                <StyledDropContainer
                                    {...getRootProps()}
                                    isDragActive={isDragActive}
                                    isDragReject={isDragReject}
                                    style={{ height: "100%" }}
                                >
                                    <input {...getInputProps()} />
                                    {renderDragMessage(
                                        isDragActive,
                                        isDragReject
                                    )}
                                    {renderMessageError(fileRejections)}
                                </StyledDropContainer>
                            )}
                        </Dropzone>
                    </div>
                    <div style={{ marginTop: "65px" }}>
                        <StyledLabel style={{ margin: "10px 0" }}>
                            {StringUtils.capitalizeFirstLetter(
                                t("observations")
                            )}
                        </StyledLabel>
                        <InputTextArea
                            placeholder={placeholder}
                            value={textArea || ""}
                            maxLength={200}
                            onChange={handleTextAreaChange}
                            style={{ height: "116px" }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                        }}
                    >
                        <StyledImportButton
                            disabled={
                                !((newfile?.length || 0) > 0) || select === ""
                            }
                            onClick={handleUploadFile}
                        >
                            Anexar
                        </StyledImportButton>
                    </div>
                </div>
            </StyledBody>
            {errorPost ? DialogErrorContent : DialogSuccessContent}
        </ThemeProvider>
    );
}

export default UploadFile;
